module.exports = __webpack_public_path__ + "static/media/fig_23b.9cb8a889.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_23b.jpg
// module id = 659
// module chunks = 0